const breakpoints = {
  base: '0px',
  xs: '320px',
  sm: '425px',
  md: '768px',
  lg: '960px',
  xl: '1100px',
  '2xl': '1536px',
};

export default breakpoints;
